import c from "../../utils/constants";

class AffiliatesController {
  constructor(AffiliatesService, FilterService, AuthService, $scope) {
    "ngInject"

    this.affiliatesService = AffiliatesService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  $onInit() {
    this.affiliateTypeOptions = {
      dataSource: [
        { value: c.affiliateType.CREDIT, text: "Credit" },
        { value: c.affiliateType.SUBSCRIPTION, text: "Membership" },
      ],
      dataTextField: "text",
      dataValueField: "value",
    };

    this.paymentTypeOptions = {
      dataSource: [
        { value: c.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION180, text: "Complete Childcare" },
        { value: c.userPaymentType.ANNUAL_FAMILY_CARE_SUBSCRIPTION240, text: "Tutoring + Childcare" },
      ],
      dataTextField: "text",
      dataValueField: "value",
    };

    this.secondaryPaymentTypeOptions = {
      dataSource: [
        { value: c.userPaymentType.NONE, text: "None" },
        { value: c.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION30, text: "Paid Membership" },
      ],
      dataTextField: "text",
      dataValueField: "value",
    };
  }

  // https://demos.telerik.com/kendo-ui/grid/detailtemplate.
  getGridOptions() {

    return {
      dataSource: this.affiliatesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
      sortable: true,
      pageable: true,
      resizable: true,
      height: "90vh",
      toolbar: [{ name: "create", text: "Create New Partnership" }],
      detailInit: this.detailInit.bind(this),
      detailTemplate: kendo.template($("#template").html()),
      noRecords: {
        template: "No Partnerships."
      },
      // dataBound: function() {
      //     this.expandRow(this.tbody.find("tr.k-master-row").first());
      // },
      columns: [
        // { field: "code", title: "Code", filterable: false, sortable: false, width: "4rem" },
        { field: "affiliateName", title: "Partner Name", filterable: false, sortable: false, width: "8rem" },
        {
          field: "fullName", title: "Referrer", filterable: false, attributes: {"class": "col-name"}, width: "8rem",
          template: (dataItem) => dataItem.jugglerId ? `<a target="_blank" class="cell" href="/users/${dataItem.jugglerId}">${dataItem.fullName}</a>` : 'None',
        },
        { field: "jugglerTypes", title: "Account Type", filterable: false, width: "6rem", template: (dataItem) => `${this._getAccountType(dataItem)}` },
        { field: "affiliateType", title: "Type", filterable: false, width: "6rem", template: (dataItem) => `${this._getAffiliateDetails(dataItem)}` },
        { field: "activationsCount", title: "Usage", filterable: false, width: "4rem", template: (dataItem) => `${this._getActivationDetails(dataItem)}` },
        // { field: "startDate", title: "Start Date", filterable: false, width: "4rem", template: `#= startDate ? kendo.toString(new Date(startDate), 'dd/MM/yyyy'): '-' #` },
        // { field: "expireDate", title: "Expire Date", filterable: false, width: "4rem", template: `#= expireDate ? kendo.toString(new Date(expireDate), 'dd/MM/yyyy'): '-' #` },
        { title: "Update", command: [{ name: "edit", text: "Update" }], width: "4rem" },
      ],
      editable: {
        mode: "popup",
        window: { title: "Partnership" },
        template: kendo.template($("#popup-editor").html()),
      }
    }
  }

  detailInit(e) {
    const data = e.data;
    const detailRow = e.detailRow;

    detailRow.find(".detailTabstrip").kendoTabStrip({
        animation: {
            open: { effects: "fadeIn" }
        }
    });

    detailRow.find(".users").kendoGrid({
      dataSource: this.affiliatesService.getAffiliateUsersDataSource(data.id),
      sortable: false,
      pageable: true,
      resizable: false,
      noRecords: {
        template: "None yet."
      },
      columns: [
        {
          field: "fullName", title: "Name", filterable: false, attributes: {"class": "col-name"}, width: "12rem",
          template: (dataItem) => `<a target="_blank" class="cell" href="/users/${dataItem.userId}">${dataItem.fullName}</a>`,
        },
        { field: "entityTypeName", title: "Account Type", filterable: false, attributes: { class: "col-account-type" }, width: "8rem" },
        { field: "accountStatusName", title: "Account Status", filterable: false, width: "8rem" },
        { field: "membershipTypeName", title: "Membership Type", filterable: false, width: "10rem" },
        { field: "creationDate", title: "Signup Date", template: `<span>#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #</span>`, filterable: false, width: "8rem" },
      ],
    });

    detailRow.find(".jobs").kendoGrid({
      dataSource: this.affiliatesService.getAffiliateJobsDataSource(data.id),
      sortable: false,
      pageable: true,
      resizable: false,
      noRecords: {
        template: "None yet."
      },
      columns: [
        { field: "month", title: "Month", template: `<span>#= kendo.toString(new Date(month), 'MMM yyyy') #</span>`, filterable: false, width: "4em" },
        { field: "jobsPosted", title: "Jobs Posted", filterable: false, sortable: false, width: "2rem" },
        { field: "jobsAwarded", title: "Jobs Awarded", filterable: false, sortable: false, width: "2rem" },
        { field: "jobsCompleted", title: "Jobs Completed", filterable: false, sortable: false, width: "2rem" },
      ],
    });
  }

  _getActivationDetails(affiliate) {
    switch(affiliate.affiliateType) {
      case c.affiliateType.CREDIT:
        return `${affiliate.activationsCount}`;
      case c.affiliateType.SUBSCRIPTION:
        return `${affiliate.activationsCount} / ${affiliate.activationsLimit}`;
    }

    return '';
  }

  _getAffiliateDetails(affiliate) {
    let details = '';
    switch(affiliate.affiliateType) {
      case c.affiliateType.CREDIT:
        details = `$${affiliate.creditAmount} Credit`;
        break;
      case c.affiliateType.SUBSCRIPTION:
        details = `${this.getPaymentType(affiliate.paymentType)}`;
        if (affiliate.secondaryPaymentType) {
          details += `, ${this.getPaymentType(affiliate.secondaryPaymentType)}`;
        }
        break;
    }

    return details;
  }

  _getAccountType(affiliate) {
    switch(affiliate.jugglerTypes) {
      case c.jugglerType.PARENT:
        return 'Parent';
      case c.jugglerType.HELPER:
        return 'Helper';
    }

    return 'None';
  }

  getPaymentType(paymentType) {
    if (!paymentType) return "-";

    switch (paymentType) {
      case c.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION120:
      case c.userPaymentType.ANNUAL_CHILDCARE_SUBSCRIPTION180:
        return 'Childcare Membership';
      case c.userPaymentType.ANNUAL_FAMILY_CARE_SUBSCRIPTION240:
        return 'Tutoring + Childcare Membership';
      case c.userPaymentType.QUARTERLY_BUSINESS_TIER1_SUBSCRIPTION_500:
        return 'Juggle St Pro Quarterly - Single Site';
      case c.userPaymentType.ANNUAL_BUSINESS_TIER1_SUBSCRIPTION_1500:
        return 'Juggle St Pro Annual - Single Site';
      case c.userPaymentType.QUARTERLY_BUSINESS_TIER2_SUBSCRIPTION_500:
        return 'Juggle St Pro Quarterly - Agency';
      case c.userPaymentType.ANNUAL_BUSINESS_TIER2_SUBSCRIPTION_1500:
        return 'Juggle St Pro Annual - Agency';
        case c.userPaymentType.ANNUAL_HELPER_SUBSCRIPTION30:
          return 'Helper Membership';
      default:
        throw new Error(`Unsupported option: ${paymentType}`);
    }
  }

  applyFilters() {
    this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
  }

  dataSourceFetchSuccessCallback(e) {
    this.affiliatesMatchCount = this.gridOptions.dataSource.total();
    this.$scope.$apply();
  }

  dataSourceErrorSuccessCallback(e) {
    if (e.xhr.status == 401) {
      this.authService.refreshToken().then((response) => {
        this.applyFilters();
      }).catch((error) => {
        this.authService.logout();
      });
    } else {
      this.authService.logout();
    }
  }

}

export default AffiliatesController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/affiliates/affiliates.controller.js
 **/